import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Users, CreditCard, Crown, TrendingUp } from 'lucide-react'
import { useAdminUsers } from '../../hooks/useAdminUsers'
import { Card } from '../../components/UI'

const AdminDashboard = () => {
  const { users, fetchUsers, loading } = useAdminUsers()
  const [stats, setStats] = useState({
    totalUsers: 0,
    activeSubscribers: 0,
    proUsers: 0,
    totalCredits: 0,
  })

  useEffect(() => {
    fetchUsers({ limit: 100 })
  }, [])

  useEffect(() => {
    if (users.length > 0) {
      setStats({
        totalUsers: users.length,
        activeSubscribers: users.filter(u => u.subscriptionStatus === 'active').length,
        proUsers: users.filter(u => u.plan === 'pro').length,
        totalCredits: users.reduce((sum, u) => sum + (u.creditsBalance || 0), 0),
      })
    }
  }, [users])

  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold">Admin Dashboard</h1>
        <p className="text-dark-400 mt-1">Overview of your Voxerface users and subscriptions</p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <Card>
          <div className="flex items-start justify-between">
            <div>
              <p className="text-sm text-dark-400">Total Users</p>
              <p className="text-3xl font-bold mt-1">
                {loading ? '-' : stats.totalUsers.toLocaleString()}
              </p>
            </div>
            <div className="p-2 bg-blue-500/10 rounded-lg">
              <Users className="w-5 h-5 text-blue-400" />
            </div>
          </div>
        </Card>

        <Card>
          <div className="flex items-start justify-between">
            <div>
              <p className="text-sm text-dark-400">Active Subscribers</p>
              <p className="text-3xl font-bold mt-1">
                {loading ? '-' : stats.activeSubscribers.toLocaleString()}
              </p>
            </div>
            <div className="p-2 bg-green-500/10 rounded-lg">
              <TrendingUp className="w-5 h-5 text-green-400" />
            </div>
          </div>
        </Card>

        <Card>
          <div className="flex items-start justify-between">
            <div>
              <p className="text-sm text-dark-400">Pro Users</p>
              <p className="text-3xl font-bold mt-1">
                {loading ? '-' : stats.proUsers.toLocaleString()}
              </p>
            </div>
            <div className="p-2 bg-accent-500/10 rounded-lg">
              <Crown className="w-5 h-5 text-accent-400" />
            </div>
          </div>
        </Card>

        <Card>
          <div className="flex items-start justify-between">
            <div>
              <p className="text-sm text-dark-400">Total Credits</p>
              <p className="text-3xl font-bold mt-1">
                {loading ? '-' : stats.totalCredits.toLocaleString()}
              </p>
            </div>
            <div className="p-2 bg-yellow-500/10 rounded-lg">
              <CreditCard className="w-5 h-5 text-yellow-400" />
            </div>
          </div>
        </Card>
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card padding="lg">
          <h3 className="text-lg font-semibold mb-4">Quick Actions</h3>
          <div className="space-y-3">
            <Link
              to="/admin/users"
              className="flex items-center gap-3 p-3 bg-dark-800 hover:bg-dark-700 rounded-lg transition-colors"
            >
              <Users className="w-5 h-5 text-accent-400" />
              <div>
                <p className="font-medium">Manage Users</p>
                <p className="text-sm text-dark-400">View and edit user accounts</p>
              </div>
            </Link>
          </div>
        </Card>

        <Card padding="lg">
          <h3 className="text-lg font-semibold mb-4">Recent Activity</h3>
          <div className="text-center py-8 text-dark-400">
            <p>Activity feed coming soon</p>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default AdminDashboard
